const tray = {
  title: "Рабочий лоток",
  pinToTray: "Закрепить в лотке",
  unpinFromTray: "Открепить",
  clearAll: "Очистить всё",
  emptyTray: "Лоток пуст — закрепите страницы для продолжения",
  splitLeft: "Разделить влево",
  splitRight: "Разделить вправо",
  closeSplit: "Закрыть разделение",
  splitActive: "Разделение экрана активно",
} as const;
export default tray;
